import * as React from 'react';
import { Ghost, Zombie, Vampire, Mage, Spider, SpiderWeb, Bat, JackOLantern } from '../';

export const Halloween = (props: { text?: string }) => {
  // const Monsters = [Ghost, Zombie, Vampire, Mage];
  const prob = Math.random() * 4;
  return (
    <>
      {/* <h1>Happy Halloween!</h1> */}
      <SpiderWeb position={{ x: 14, y: -3 }} />
      <SpiderWeb position={{ x: 93, y: -3 }} />
      {prob < 1 && <Ghost />}
      {prob > 1 && prob < 2 && <Zombie />}
      {prob > 2 && prob < 3 && <Vampire />}
      {prob > 3 && <Mage />}
      {/* {React.createElement(Monsters[Math.floor(Math.random() * (Monsters.length - 1))])} */}
      {/* <Ghost /> */}
      <Spider position={{ x: 14, y: 5 }} />
      <Spider position={{ x: 93, y: 5 }} />

      <Bat />
      <Bat />
      <Bat />
      <Bat />
      <Bat />
      <Bat />
      <Bat />
      <JackOLantern />
    </>
  );
};



// WEBPACK FOOTER //
// ./src/common/components/emoji/_components/Halloween.tsx